import { queryExtendedBookings } from '@wix/ambassador-bookings-reader-v2-extended-booking/http';
export const queryBookings = async ({ status, serviceType, startDate }, { httpClient }) => {
    const { data: response } = await httpClient.request(queryExtendedBookings({
        query: {
            filter: {
                ...(status ? { status } : {}),
                ...(serviceType ? { 'bookedEntity.tags': serviceType } : {}),
                ...(startDate ? { startDate: { $gte: startDate } } : {}),
            },
        },
    }));
    return response.extendedBookings;
};
//# sourceMappingURL=queryBookings.js.map